import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { CheckCircle2, Loader2, XCircle } from 'lucide-react';

export const AutoCategoryImporter = () => {
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('Initializing import...');
  const [result, setResult] = useState<any>(null);

  useEffect(() => {
    const runImport = async () => {
      try {
        setMessage('Fetching CSV data...');
        const response = await fetch('/MinorSoccerTalks_simplified.csv');
        if (!response.ok) throw new Error('Failed to fetch CSV file');
        
        const csvData = await response.text();
        setMessage(`CSV loaded (${csvData.split('\n').length} lines). Starting import...`);

        const { data, error } = await supabase.functions.invoke('import-categories', {
          body: { csvData }
        });

        if (error) throw error;

        setStatus('success');
        setMessage('Import completed successfully!');
        setResult(data);
      } catch (error: any) {
        console.error('Import error:', error);
        setStatus('error');
        setMessage(error.message || 'Import failed');
      }
    };

    runImport();
  }, []);

  return (
    <Alert className={
      status === 'success' ? 'border-green-500 bg-green-50' :
      status === 'error' ? 'border-red-500 bg-red-50' :
      'border-blue-500 bg-blue-50'
    }>
      <div className="flex items-start gap-3">
        {status === 'loading' && <Loader2 className="h-5 w-5 animate-spin text-blue-600" />}
        {status === 'success' && <CheckCircle2 className="h-5 w-5 text-green-600" />}
        {status === 'error' && <XCircle className="h-5 w-5 text-red-600" />}
        
        <div className="flex-1">
          <AlertDescription>
            <p className="font-semibold mb-2">{message}</p>
            {result && (
              <div className="mt-2 text-sm space-y-1">
                <p>✅ Imported: {result.imported}</p>
                <p>⏭️ Skipped: {result.skipped}</p>
                {result.errors > 0 && <p>❌ Errors: {result.errors}</p>}
              </div>
            )}
          </AlertDescription>
        </div>
      </div>
    </Alert>
  );
};
